import { render, staticRenderFns } from "./ACollections.vue?vue&type=template&id=74869c8e&scoped=true"
import script from "./ACollections.vue?vue&type=script&lang=js"
export * from "./ACollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74869c8e",
  null
  
)

export default component.exports